import { useEffect, useContext, useState, useRef } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { SessionContext } from "../context/SessionContext";
import { ProfileContext } from "../context/ProfileContext";
import { toast } from "react-hot-toast";

import ToastDisplay from "../components/ToastDisplay";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Pagination from "../components/Pagination";
import PageLoader from "../components/PageLoader";
import Empty from "../components/Empty";

const Roles = () => {
	const navigate = useNavigate();
	const photoRef = useRef(null);
	const [session] = useContext(SessionContext);
	const [profile] = useContext(ProfileContext);
	const [roles, setRoles] = useState([]);
	const [meta, setMeta] = useState(null);
	const [searchParams, setSearchParams] = useSearchParams({});
	const [loading, setLoading] = useState(true);
	const [actionLoading, setActionLoading] = useState(false);
	const [filtermodal, setFilterModal] = useState(false);
	const [showFilters, setShowFilters] = useState(false);
	const [roleModal, setRoleModal] = useState(false);
	const [errors, setErrors] = useState([]);
	const [name, setName] = useState("");

	const [logsView, setLogsView] = useState(false);
	const [logsAdd, setLogsAdd] = useState(false);
	const [logsEdit, setLogsEdit] = useState(false);
	const [logsDelete, setLogsDelete] = useState(false);
	const [announcementsView, setAnnouncementsView] = useState(false);
	const [announcementsAdd, setAnnouncementsAdd] = useState(false);
	const [announcementsEdit, setAnnouncementsEdit] = useState(false);
	const [announcementsDelete, setAnnouncementsDelete] = useState(false);
	const [studentsView, setStudentsView] = useState(false);
	const [studentsAdd, setStudentsAdd] = useState(false);
	const [studentsEdit, setStudentsEdit] = useState(false);
	const [studentsDelete, setStudentsDelete] = useState(false);
	const [personnelView, setPersonnelView] = useState(false);
	const [personnelAdd, setPersonnelAdd] = useState(false);
	const [personnelEdit, setPersonnelEdit] = useState(false);
	const [personnelDelete, setPersonnelDelete] = useState(false);
	const [usersView, setUsersView] = useState(false);
	const [usersAdd, setUsersAdd] = useState(false);
	const [usersEdit, setUsersEdit] = useState(false);
	const [usersDelete, setUsersDelete] = useState(false);
	const [rolesView, setRolesView] = useState(false);
	const [rolesAdd, setRolesAdd] = useState(false);
	const [rolesEdit, setRolesEdit] = useState(false);
	const [rolesDelete, setRolesDelete] = useState(false);
	const [devicesView, setDevicesView] = useState(false);
	const [devicesAdd, setDevicesAdd] = useState(false);
	const [devicesEdit, setDevicesEdit] = useState(false);
	const [devicesDelete, setDevicesDelete] = useState(false);
	const [driversView, setDriversView] = useState(false);
	const [driversAdd, setDriversAdd] = useState(false);
	const [driversEdit, setDriversEdit] = useState(false);
	const [driversDelete, setDriversDelete] = useState(false);

	const [searchQ, setSearchQ] = useState(searchParams.get("q") || "");
	const [searchRole, setSearchRole] = useState(searchParams.get("role") || "");
	const [searchStatus, setSearchStatus] = useState(
		searchParams.get("status") || ""
	);

	const searchFields = [{ key: "q", value: searchQ }];

	const filterFields = [];

	const requiredFields = [{ key: "name", value: name }];

	const getData = async () => {
		setLoading(true);
		const requestOptions = {
			method: "GET",
			headers: { "X-Auth-Token": session },
		};

		const response = await fetch(
			`${process.env.REACT_APP_API_URI}/users/roles`,
			requestOptions
		);
		const data = await response.json();

		if (!response.ok) {
			toast(<ToastDisplay status="error" content="Something went wrong." />);
		} else {
			setRoles(data.roles);
			setMeta(data.meta);
		}
		setLoading(false);
	};

	const search = (e) => {
		e.preventDefault();
		var newSearch = { ...searchParams };
		searchFields.map((field) => {
			if (field.value !== "") {
				newSearch[field.key] = field.value;
			} else {
				delete newSearch[field.key];
			}
		});
		setSearchParams(newSearch);
		setFilterModal(false);
	};

	const removeFilter = (e, func, key) => {
		e.preventDefault();
		func("");
		var newSearch = { ...searchParams };
		searchFields.map((field) => {
			if (field.value !== "" && field.key !== key) {
				newSearch[field.key] = field.value;
			} else {
				delete newSearch[field.key];
			}
		});
		setSearchParams(newSearch);
	};

	const clearFilters = (e) => {
		e.preventDefault();
		setSearchParams({});
		filterFields.map((field) => {
			field.edit(field.defaultVal);
		});
	};

	const closeRoleModal = () => {
		setRoleModal(false);
		setName("");
		setLogsView(false);
		setLogsAdd(false);
		setLogsEdit(false);
		setLogsDelete(false);
		setAnnouncementsView(false);
		setAnnouncementsAdd(false);
		setAnnouncementsEdit(false);
		setAnnouncementsDelete(false);
		setStudentsView(false);
		setStudentsAdd(false);
		setStudentsEdit(false);
		setStudentsDelete(false);
		setPersonnelView(false);
		setPersonnelAdd(false);
		setPersonnelEdit(false);
		setPersonnelDelete(false);
		setUsersView(false);
		setUsersAdd(false);
		setUsersEdit(false);
		setUsersDelete(false);
		setRolesView(false);
		setRolesAdd(false);
		setRolesEdit(false);
		setRolesDelete(false);
		setDevicesView(false);
		setDevicesAdd(false);
		setDevicesEdit(false);
		setDevicesDelete(false);
		setDriversView(false);
		setDriversAdd(false);
		setDriversEdit(false);
		setDriversDelete(false);
		setErrors([]);
	};

	const isEmpty = (value) => {
		return value === "" || value === null || value === undefined;
	};

	const saveRole = async () => {
		const requestOptions = {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"X-Auth-Token": session,
			},
			body: JSON.stringify({
				name: name,
				logs_view: logsView,
				logs_write: logsAdd,
				logs_edit: logsEdit,
				logs_delete: logsDelete,
				announcements_view: announcementsView,
				announcements_write: announcementsAdd,
				announcements_edit: announcementsEdit,
				announcements_delete: announcementsDelete,
				students_view: studentsView,
				students_write: studentsAdd,
				students_edit: studentsEdit,
				students_delete: studentsDelete,
				personnel_view: personnelView,
				personnel_write: personnelAdd,
				personnel_edit: personnelEdit,
				personnel_delete: personnelDelete,
				users_view: usersView,
				users_write: usersAdd,
				users_edit: usersEdit,
				users_delete: usersDelete,
				roles_view: rolesView,
				roles_write: rolesAdd,
				roles_edit: rolesEdit,
				roles_delete: rolesDelete,
				devices_view: devicesView,
				devices_write: devicesAdd,
				devices_edit: devicesEdit,
				devices_delete: devicesDelete,
				drivers_view: driversView,
				drivers_write: driversAdd,
				drivers_edit: driversEdit,
				drivers_delete: driversDelete,
			}),
		};

		const response = await fetch(
			`${process.env.REACT_APP_API_URI}/users/roles/`,
			requestOptions
		);
		const data = await response.json();

		if (!response.ok) {
			toast(
				<ToastDisplay
					status="error"
					content={data.msg}
					details={data.details}
				/>
			);
		} else {
			toast(<ToastDisplay status="success" content={data.msg} />);
			closeRoleModal();
			navigate(`/roles/${data.role_id}`);
		}
		setActionLoading(false);
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		setActionLoading(true);
		var newErrors = [];

		requiredFields.map((field) => {
			if (!field.value || field.value === "" || field.value.length === 0) {
				newErrors.push(field.key);
			}
		});

		if (newErrors.length !== 0) {
			toast(
				<ToastDisplay
					status="error"
					content="Please fill out all required fields."
				/>
			);
			setActionLoading(false);
			setErrors(newErrors);
			return;
		}
		saveRole();
	};

	const handleAnnouncementsView = () => {
		if (announcementsView) {
			setAnnouncementsAdd(false);
		}
		setAnnouncementsView(!announcementsView);
	};

	const handleStudentsView = () => {
		if (studentsView) {
			setStudentsAdd(false);
			setStudentsEdit(false);
			setStudentsDelete(false);
		}
		setStudentsView(!studentsView);
	};

	const handlePersonnelView = () => {
		if (personnelView) {
			setPersonnelAdd(false);
			setPersonnelEdit(false);
			setPersonnelDelete(false);
		}
		setPersonnelView(!personnelView);
	};

	const handleDevicesView = () => {
		if (devicesView) {
			setDevicesAdd(false);
			setDevicesEdit(false);
			setDevicesDelete(false);
		}
		setDevicesView(!devicesView);
	};

	const handleDriversView = () => {
		if (driversView) {
			setDriversAdd(false);
			setDriversEdit(false);
			setDriversDelete(false);
		}
		setDriversView(!driversView);
	};

	const handleUsersView = () => {
		if (usersView) {
			setUsersAdd(false);
			setUsersEdit(false);
			setUsersDelete(false);
		}
		setUsersView(!usersView);
	};

	const handleRolesView = () => {
		if (rolesView) {
			setRolesAdd(false);
			setRolesEdit(false);
			setRolesDelete(false);
		}
		setRolesView(!rolesView);
	};

	useEffect(() => {
		document.title = "Roles | Pisara Dashboard";
		if (profile) {
			if (!profile.role.roles_view) {
				navigate("/");
			} else {
				getData();
				if (filterFields.every((field) => isEmpty(field.value))) {
					setShowFilters(false);
				} else {
					setShowFilters(true);
				}
			}
		}
	}, [searchParams, profile]);

	return (
		<>
			<Container className="gx-5">
				<Row className="content-header flex-row-left mb-20">
					<Col>
						<h1 className="text-xl m-0">Roles</h1>
					</Col>
				</Row>
				<Row className="flex-row-left mb-20">
					<Col className="col-5">
						<Form onSubmit={search}>
							<div className="search-container bg-white flex-row-left">
								<i className="ri-search-line search-icon" />
								<Form.Control
									className="text-sm"
									placeholder="Search roles"
									value={searchQ}
									onChange={(e) => setSearchQ(e.target.value)}
								/>
							</div>
						</Form>
					</Col>
					<Col className="col-7 flex-row-right">
						<Pagination
							meta={meta}
							searchParams={searchParams}
							setSearchParams={setSearchParams}
							searchFields={searchFields}
							className="pull-right flex-row-left"
						/>
						<Button
							variant="light"
							className={`refresh-btn flex-column ${
								!profile?.role?.roles_write && "no-margin"
							}`}
							onClick={getData}
						>
							<i className="ri-restart-line opacity-7" />
						</Button>
						{profile?.role?.roles_write && (
							<Button
								className="control-btn btn-sm btn-default text-medium-gotham text-sm"
								onClick={() => setRoleModal(true)}
							>
								<i className="ri-lock-2-line" />
								Add Role
							</Button>
						)}
					</Col>
				</Row>
				<Row className="content-table-header bg-white gx-0">
					<Col className="p-10">
						<span className="text-sm text-medium-gotham mb-10 block">Name</span>
					</Col>
				</Row>
				{loading ? (
					<PageLoader className="bg-white p-50" />
				) : roles?.length === 0 ? (
					<Empty label="No roles to show." className="bg-white" />
				) : (
					roles.map((role) => (
						<Link key={role.id} to={`/roles/${role.id}`}>
							<Row className="content-table-item bg-white gx-0">
								<Col className="p-10 ellipsis">
									<span className="text-sm">{role.name}</span>
								</Col>
							</Row>
						</Link>
					))
				)}
			</Container>
			<Modal
				show={roleModal}
				className="info-modal admin-content"
				centered
				size="lg"
				onHide={closeRoleModal}
			>
				<Form onSubmit={handleSubmit}>
					<Modal.Header>
						<Modal.Title className="text-lg">Add Role</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="mb-10">
							<h2 className="text-lg text-medium-gotham mb-0">
								User Information
							</h2>
						</div>
						<Row className="mb-30">
							<Col>
								<Form.Label className="text-sm">Name</Form.Label>
								<Form.Control
									autoFocus
									className={`text-sm form-input ${
										errors.includes("name") && "border-danger"
									}`}
									value={name}
									onChange={(e) => setName(e.target.value)}
								/>
							</Col>
						</Row>
						<div className="mb-10">
							<h2 className="text-lg text-medium-gotham mb-0">Permissions</h2>
						</div>
						<div className="border rounded-8 p-20 mb-20">
							<div className="mb-20">
								<span className="text-medium-gotham">Logs</span>
							</div>
							<Row>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={logsView}
										id="logsView"
										onChange={() => setLogsView(!logsView)}
									/>
									<label htmlFor="logsView" className="lbl m-0" />
									<span className="text-sm ms-3">View</span>
								</Col>
								<Col />
								<Col />
								<Col />
							</Row>
						</div>
						<div className="border rounded-8 p-20 mb-20">
							<div className="mb-20">
								<span className="text-medium-gotham">Announcements</span>
							</div>
							<Row>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={announcementsView}
										id="announcementsView"
										onChange={handleAnnouncementsView}
									/>
									<label htmlFor="announcementsView" className="lbl m-0" />
									<span className="text-sm ms-3">View</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={announcementsAdd}
										id="announcementsAdd"
										onChange={() => {
											setAnnouncementsAdd(!announcementsAdd);
											setAnnouncementsView(true);
										}}
									/>
									<label htmlFor="announcementsAdd" className="lbl m-0" />
									<span className="text-sm ms-3">Add</span>
								</Col>
								<Col />
								<Col />
							</Row>
						</div>
						<div className="border rounded-8 p-20 mb-20">
							<div className="mb-20">
								<span className="text-medium-gotham">Students</span>
							</div>
							<Row>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={studentsView}
										id="studentsView"
										onChange={handleStudentsView}
									/>
									<label htmlFor="studentsView" className="lbl m-0" />
									<span className="text-sm ms-3">View</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={studentsAdd}
										id="studentsAdd"
										onChange={() => {
											setStudentsAdd(!studentsAdd);
											setStudentsView(true);
										}}
									/>
									<label htmlFor="studentsAdd" className="lbl m-0" />
									<span className="text-sm ms-3">Add</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={studentsEdit}
										id="studentsEdit"
										onChange={() => {
											setStudentsEdit(!studentsEdit);
											setStudentsView(true);
										}}
									/>
									<label htmlFor="studentsEdit" className="lbl m-0" />
									<span className="text-sm ms-3">Edit</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={studentsDelete}
										id="studentsDelete"
										onChange={() => {
											setStudentsDelete(!studentsDelete);
											setStudentsView(true);
										}}
									/>
									<label htmlFor="studentsDelete" className="lbl m-0" />
									<span className="text-sm ms-3">Delete</span>
								</Col>
							</Row>
						</div>
						<div className="border rounded-8 p-20 mb-20">
							<div className="mb-20">
								<span className="text-medium-gotham">Personnel</span>
							</div>
							<Row>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={personnelView}
										id="personnelView"
										onChange={handlePersonnelView}
									/>
									<label htmlFor="personnelView" className="lbl m-0" />
									<span className="text-sm ms-3">View</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={personnelAdd}
										id="personnelAdd"
										onChange={() => {
											setPersonnelAdd(!personnelAdd);
											setPersonnelView(true);
										}}
									/>
									<label htmlFor="personnelAdd" className="lbl m-0" />
									<span className="text-sm ms-3">Add</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={personnelEdit}
										id="personnelEdit"
										onChange={() => {
											setPersonnelEdit(!personnelEdit);
											setPersonnelView(true);
										}}
									/>
									<label htmlFor="personnelEdit" className="lbl m-0" />
									<span className="text-sm ms-3">Edit</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={personnelDelete}
										id="personnelDelete"
										onChange={() => {
											setPersonnelDelete(!personnelDelete);
											setPersonnelView(true);
										}}
									/>
									<label htmlFor="personnelDelete" className="lbl m-0" />
									<span className="text-sm ms-3">Delete</span>
								</Col>
							</Row>
						</div>
						<div className="border rounded-8 p-20 mb-20">
							<div className="mb-20">
								<span className="text-medium-gotham">Devices</span>
							</div>
							<Row>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={devicesView}
										id="devicesView"
										onChange={handleDevicesView}
									/>
									<label htmlFor="devicesView" className="lbl m-0" />
									<span className="text-sm ms-3">View</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={devicesAdd}
										id="devicesAdd"
										onChange={() => {
											setDevicesAdd(!devicesAdd);
											setDevicesView(true);
										}}
									/>
									<label htmlFor="devicesAdd" className="lbl m-0" />
									<span className="text-sm ms-3">Add</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={devicesEdit}
										id="devicesEdit"
										onChange={() => {
											setDevicesEdit(!devicesEdit);
											setDevicesView(true);
										}}
									/>
									<label htmlFor="devicesEdit" className="lbl m-0" />
									<span className="text-sm ms-3">Edit</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={devicesDelete}
										id="devicesDelete"
										onChange={() => {
											setDevicesDelete(!devicesDelete);
											setDevicesView(true);
										}}
									/>
									<label htmlFor="devicesDelete" className="lbl m-0" />
									<span className="text-sm ms-3">Delete</span>
								</Col>
							</Row>
						</div>
						<div className="border rounded-8 p-20 mb-20">
							<div className="mb-20">
								<span className="text-medium-gotham">Drivers</span>
							</div>
							<Row>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={driversView}
										id="driversView"
										onChange={handleDriversView}
									/>
									<label htmlFor="driversView" className="lbl m-0" />
									<span className="text-sm ms-3">View</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={driversAdd}
										id="driversAdd"
										onChange={() => {
											setDriversAdd(!driversAdd);
											setDriversView(true);
										}}
									/>
									<label htmlFor="driversAdd" className="lbl m-0" />
									<span className="text-sm ms-3">Add</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={driversEdit}
										id="driversEdit"
										onChange={() => {
											setDriversEdit(!driversEdit);
											setDriversView(true);
										}}
									/>
									<label htmlFor="driversEdit" className="lbl m-0" />
									<span className="text-sm ms-3">Edit</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={driversDelete}
										id="driversDelete"
										onChange={() => {
											setDriversDelete(!driversDelete);
											setDriversView(true);
										}}
									/>
									<label htmlFor="driversDelete" className="lbl m-0" />
									<span className="text-sm ms-3">Delete</span>
								</Col>
							</Row>
						</div>
						<div className="border rounded-8 p-20 mb-20">
							<div className="mb-20">
								<span className="text-medium-gotham">Users</span>
							</div>
							<Row>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={usersView}
										id="usersView"
										onChange={handleUsersView}
									/>
									<label htmlFor="usersView" className="lbl m-0" />
									<span className="text-sm ms-3">View</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={usersAdd}
										id="usersAdd"
										onChange={() => {
											setUsersAdd(!usersAdd);
											setUsersView(true);
										}}
									/>
									<label htmlFor="usersAdd" className="lbl m-0" />
									<span className="text-sm ms-3">Add</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={usersEdit}
										id="usersEdit"
										onChange={() => {
											setUsersEdit(!usersEdit);
											setUsersView(true);
										}}
									/>
									<label htmlFor="usersEdit" className="lbl m-0" />
									<span className="text-sm ms-3">Edit</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={usersDelete}
										id="usersDelete"
										onChange={() => {
											setUsersDelete(!usersDelete);
											setUsersView(true);
										}}
									/>
									<label htmlFor="usersDelete" className="lbl m-0" />
									<span className="text-sm ms-3">Delete</span>
								</Col>
							</Row>
						</div>
						<div className="border rounded-8 p-20 mb-20">
							<div className="mb-20">
								<span className="text-medium-gotham">Roles & Permissions</span>
							</div>
							<Row>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={rolesView}
										id="rolesView"
										onChange={handleRolesView}
									/>
									<label htmlFor="rolesView" className="lbl m-0" />
									<span className="text-sm ms-3">View</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={rolesAdd}
										id="rolesAdd"
										onChange={() => {
											setRolesAdd(!rolesAdd);
											setRolesView(true);
										}}
									/>
									<label htmlFor="rolesAdd" className="lbl m-0" />
									<span className="text-sm ms-3">Add</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={rolesEdit}
										id="rolesEdit"
										onChange={() => {
											setRolesEdit(!rolesEdit);
											setRolesView(true);
										}}
									/>
									<label htmlFor="rolesEdit" className="lbl m-0" />
									<span className="text-sm ms-3">Edit</span>
								</Col>
								<Col className="flex-row-left">
									<input
										type="checkbox"
										className="cbx hidden"
										checked={rolesDelete}
										id="rolesDelete"
										onChange={() => {
											setRolesDelete(!rolesDelete);
											setRolesView(true);
										}}
									/>
									<label htmlFor="rolesDelete" className="lbl m-0" />
									<span className="text-sm ms-3">Delete</span>
								</Col>
							</Row>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<Button
							variant="outline-secondary"
							className="btn-sm action-btn text-sm text-medium-inter me-2"
							onClick={closeRoleModal}
						>
							Cancel
						</Button>
						<Button
							type="submit"
							className="btn-default btn-sm action-btn flex-column text-sm text-medium-inter"
							disabled={actionLoading}
						>
							{actionLoading ? (
								<Spinner className="btn-loader text-white" />
							) : (
								"Save"
							)}
						</Button>
					</Modal.Footer>
				</Form>
			</Modal>
		</>
	);
};

export default Roles;
